import React from "react";

export default ({ children, title }) => (
  <div className="container">
    <div className="row">
      <div className="col-md-4 col-md-offset-4">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">{title}</h3>
          </div>
          <div className="panel-body">{children}</div>
        </div>
      </div>
    </div>
  </div>
);
